export const walletUbos = [
  { value: 'true', text: 'yes' },
  { value: 'false', text: 'no' }
];
